import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Cpu } from 'lucide-react';

const FloatingAIChat = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === '/ai-agent') return null;

  return (
    <button
      onClick={() => navigate('/ai-agent')}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 shrink-0 aspect-square rounded-full bg-blue-600 text-white shadow-lg hover:bg-blue-700 flex items-center justify-center p-0"
      title="AI Assistant"
    >
      <Cpu className="w-6 h-6" />
    </button>
  );
};

export default FloatingAIChat;
